import { get } from 'lodash';
import {
  createAPILifecycleActions,
  createAPILifecycleActionTypes,
} from '../../../../../../../redux/actions/action_utils';
import createAmplifyAPICallEpic from '../../../../../../../redux/epics/utils';
import { UPDATE_GROUPING_ENDPOINT } from '../../../../../../../common/config/api_endpoints';

export const UPDATE_LABOR_GROUPING_ACTION_TYPES = createAPILifecycleActionTypes(
  'UPDATE_LABOR_GROUPING_ACTION_TYPES',
);
export const updateLaborGroupingAction = createAPILifecycleActions(
  UPDATE_LABOR_GROUPING_ACTION_TYPES.NAME,
);

const initialState = {
  isFetching: false,
  data: null,
  error: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case UPDATE_LABOR_GROUPING_ACTION_TYPES.BEGIN:
      return {
        ...state,
        isFetching: true,
      };
    case UPDATE_LABOR_GROUPING_ACTION_TYPES.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: {
          groupingId: get(payload, 'groupingId'),
          status: get(payload, 'status'),
        },
        error: null,
      };
    case UPDATE_LABOR_GROUPING_ACTION_TYPES.FAILURE:
      return {
        ...state,
        isFetching: false,
        data: null,
        error: payload,
      };

    case UPDATE_LABOR_GROUPING_ACTION_TYPES.CLEAR:
      return initialState;
    default:
      return state;
  }
};

export const updateLaborGroupingEpic = createAmplifyAPICallEpic({
  actionType: UPDATE_LABOR_GROUPING_ACTION_TYPES.BEGIN,
  api: UPDATE_GROUPING_ENDPOINT,
  successCallback: response => [updateLaborGroupingAction.SUCCESS(response)],
  errorCallback: () => [updateLaborGroupingAction.FAILURE()],
});
